import React from 'react';

import { ModuleDispatcher } from '$partials/modules/index.js';
import { PageShell } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HomePage}
 */
const HomePage = (props) => {
    const page = props.data?.page;

    const content = page?.content || [];

    return (
        <PageShell
            isParentHomePage
            background={page?.background}
            footer={props.data?.footer}
            header={props.data?.header}>
            {/* Page header */}
            {page.introduction && (
                <div className='layout-container home-page py-16 sm:py-0 bg-neutral-00'>
                    <div className='layout-grid'>
                        <div className='w-10/12 sm:w-6/12 layout-grid-col'>
                            <div
                                className='rich-text type-style-heading sm:w-[90%]'
                                dangerouslySetInnerHTML={{ __html: page.introduction }} />
                        </div>
                    </div>
                </div>
            )}

            {/* Streamfield modules */}
            {content.length > 0 && (
                <div className='home-page'>
                    {content.map((module) => (
                        <ModuleDispatcher
                            key={module.id}
                            modulePaddingClasses='pb-16 sm:pb-80 pt-24 sm:pt-32'
                            { ...module } />
                    ))}
                </div>
            )}
        </PageShell>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default HomePage;
